import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './StickyCTA.css';

/**
 * StickyCTA — a floating "Work With Us" button that fades in after the user
 * scrolls past the hero and hides again near the bottom (where the contact
 * form already is). Recommended landing-page conversion pattern.
 */
const StickyCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const pastHero = y > window.innerHeight * 0.8;
      const nearBottom =
        window.innerHeight + y > document.body.scrollHeight - 720;
      setShow(pastHero && !nearBottom);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goToContact = () =>
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          type="button"
          className="sticky-cta"
          onClick={goToContact}
          aria-label="Work with us — go to contact"
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          <span>Work With Us</span>
          <span className="sticky-cta__arrow" aria-hidden="true">→</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
